

































































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import { MediaListFilters as Filters } from '@/modules/media/api'

/**
 * Lista de filtros
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class MediaListFilters extends Vue {
    /**
     * Filtros
     */
    @Prop({type: Filters, default: () => new Filters()})
    public value: Filters

    @Prop({type: Boolean, default: () => false})
    public show: boolean

    public filters = new Filters()

    /**
     * Tipos de contenidos que el usuario puede utilizar para filtrar
     */
    public types = [
        { type: 'video', name: 'Videos', icon: 'mdi-video'},
        { type: 'image', name: 'Imágenes', icon: 'photo'},
        { type: 'application/pdf', name: 'Archivos PDF', icon: 'mdi-file-pdf-box'},
        { type: '', name: 'Todos', icon: 'mdi-file'},
    ]

    /**
     * Establece el filtro para la búsqueda por nombre o título de archivo
     */
    public nameSearch = _.debounce(function (this: MediaListFilters, search: string) {
        // Esta vacío o es igual que la anterior búsqueda
        if (search === this.filters.name) {
            return
        }

        this.updateFilter('name', search)
    }, 500)

    /**
     * Establece el filtro para la búsqueda por nombre o título de archivo
     */
    public creatorSearch = _.debounce(function (this: MediaListFilters, search: string) {
        // Esta vacío o es igual que la anterior búsqueda
        if (search === this.filters.creatorName) {
            return
        }

        this.updateFilter('creatorName', search)
    }, 500)

    public updateFilter (field: string, val: any) {
        _.set(this.filters, field, val)

        this.$emit('input', this.filters)
    }

    public clearFilters () {
        Object.assign(this.filters, {
            name: '',
            tags: [],
            type: '',
            creatorName: '',
            includeDeleted: false,
        })

        this.$emit('input', this.filters)
    }

    @Watch('value', {deep: true, immediate: true})
    public onValueChange (value: Filters) {
        // Clona el objeto de los filtros para evitar modificar las referencias
        this.filters = _.clone(value)
    }
}
